import React, { useState, useEffect } from "react";
import {
  Space,
  Table,
  Form,
  theme,
  Row,
  Button,
  Col,
  Input,
  message,
  Modal,
  Select,
} from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import AddUser from "./operationBtnModal";
import ConnentRole from "./connent";
import axios from "axios";
import localhost from "../../constants/localhost";

export const KEYS = {
  NAME: "name",
  PHONE: "phone",
  SEX: "sex",
  DEPARTMENT: "dept",
  ROLE: "role",
  CITY: "location",
  hobby: "hobby",
};

const mockData = Array(10)
  .fill(null)
  .map((_, index) => {
    return {
      id: index,
      name: `贵州售后经销商账号-${index + 1}`,
      [KEYS.PHONE]: "14613765431",
      [KEYS.SEX]: 1,
      [KEYS.DEPARTMENT]: "贵州售后经销商",
      [KEYS.ROLE]: "管理员",
      [KEYS.CITY]: "贵州",
      [KEYS.LOVE]: "露营、采风",
      modifyDate: "2025-3-08 16:10:41",
      createDate: "2025-6-20 13:20:11",
    };
  });

const UserMng = () => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const [dataInfo, setDataInfo] = useState({
    total: 20,
    dataSource: mockData,
  });
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    const formData = form.getFieldsValue();
    axios
      .post(`${localhost}/manage/user/queryList`, {
        pageNo: 1,
        pageSize: 20,
        ...formData,
      })
      .then((res) => {
        setDataInfo({
          total: res?.data?.total || 0,
          dataSource: res?.data?.list || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const pagination = {
    showTotal: (total, range) => {
      return `当前第 ${range[0]} 到 ${range[1]} 条，总共${total}条数据`;
    },
    total: dataInfo.total,
    current: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
    onChange: (page, pageSize) => {
      setPageInfo({ pageNo: page, pageSize: pageSize }, () => {
        getData();
      });
    },
    onShowSizeChange: (current, size) => {
      setPageInfo({ pageNo: current, pageSize: size }, () => {
        getData();
      });
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const onSearch = () => {
    setPageInfo({ pageNo: 1, pageSize: 10 });
    getData();
  };

  const onReset = () => {
    form.resetFields();
    setPageInfo({ pageNo: 1, pageSize: 10 });
    getData();
  };

  const formStyle = {
    maxWidth: "none",
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const columns = [
    {
      title: "姓名",
      dataIndex: KEYS.NAME,
      fixed: "left",
    },
    {
      title: "手机号",
      dataIndex: KEYS.PHONE,
      minWidth: 150,
    },
    {
      title: "性别",
      dataIndex: KEYS.SEX,
      minWidth: 150,
      render: (val) => (val === 1 ? "男" : "女"),
    },
    {
      title: "部门",
      dataIndex: KEYS.DEPARTMENT,
      minWidth: 150,
    },
    {
      title: "角色",
      dataIndex: KEYS.ROLE,
      minWidth: 150,
      render: (_, row) =>
        row.userRoleList?.map(({ roleName }) => roleName).join("、"),
    },
    {
      title: "归属地",
      dataIndex: KEYS.CITY,
      minWidth: 150,
    },
    {
      title: "喜好",
      dataIndex: KEYS.LOVE,
      minWidth: 150,
    },
    {
      title: "创建时间",
      dataIndex: "createDate",
    },
    {
      title: "修改时间",
      dataIndex: "modifyDate",
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <AddUser mode="edit" detail={record} />
          <a
            onClick={() => {
              Modal.confirm({
                width: 450,
                title: `请确认是否进行删除操作！`,
                icon: <ExclamationCircleFilled />,
                content: "温馨提示：删除之后可能会影响客户操作！",
                okText: "确定",
                cancelText: "取消",
                onOk() {
                  axios
                    .get(`${localhost}/manage/user/delete?id=${record.id}`)
                    .then((res) => {
                      message.success("删除成功！");
                      setPageInfo({ pageNo: 1, pageSize: 10 });
                      getData();
                    })
                    .catch((error) => {
                      message.error("网络异常，请重试！");
                    });
                },
                onCancel() {},
              });
            }}
          >
            删除
          </a>
          <ConnentRole
            userIds={record.id}
            type="single"
            successCb={() => {
              getData();
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Form form={form} style={formStyle} onFinish={onFinish}>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name={KEYS.NAME} label="姓名">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name={KEYS.PHONE} label="手机号">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name={KEYS.SEX} label="性别">
                <Select allowClear>
                  <Select.Option value={2}>女</Select.Option>
                  <Select.Option value={1}>男</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name={KEYS.ROLE} label="角色">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name={KEYS.CITY} label="归属地">
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <div style={{ textAlign: "right" }}>
                <Space size="small">
                  <Button type="primary" onClick={onSearch}>
                    搜索
                  </Button>
                  <Button onClick={onReset}>重置</Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <div style={{ textAlign: "right" }}>
        <AddUser mode="create" />
        <ConnentRole
          type="batch"
          userIds={selectedRowKeys}
          successCb={() => {
            getData();
          }}
        />
      </div>
      <div style={{ marginTop: 16 }}>
        <Table
          rowKey="id"
          columns={columns}
          scroll={{ x: "max-content", y: "calc(100vh - 240px - 55px - 64px)" }}
          style={{
            height: "calc(100vh - 240px)",
            overflowY: "scroll",
          }}
          rowSelection={{
            selectedRowKeys,
            onChange: (keys, selectedRows) => {
              console.log("selectedRowKeys changed: ", keys);
              setSelectedRowKeys(keys);
            },
          }}
          // loading={loading}
          dataSource={dataInfo.dataSource}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default UserMng;
